import WbHttpClient from '../../../services/wbhttpclient';

export default class RelatedWorkServices {
  constructor() {
    this.WbHttpClient = new WbHttpClient();
  }

  save(params) {
    return this.WbHttpClient.post('metricRelations/saveMetricRelations', params);
  }

  delete(params) {
    return this.WbHttpClient.post('metricRelations/deleteMetricRelations', params);
  }

  getList(params) {
    return this.WbHttpClient.get('metricRelations/getMetricRelations', params);
  }

  getCreateWorkstreamForm() {
    return this.WbHttpClient.post('tag/addWorksream', { teamId: "", columnId: 0 });
  }

  getAllJiraInstances(params = { app: 'jira' }) {
    return this.WbHttpClient.get("integration/getAllInstances", params);
  }

  validateJql(jql, instanceUrl) {
    const params = {
      qcomplete: jql,
      instance_url: instanceUrl
    };
    return this.WbHttpClient.post("integration/queryExtProjects?app=jira", params);
  }
}